/**
 * Syncs the current PostHog distinct_id into a Shopify cart attribute
 * (`ph_distinct_id`) so that a downstream checkout-side pixel can read it
 * off `checkout.attributes` during `checkout_completed` and report the
 * completed order back to PostHog under the SAME identity that was
 * bucketed into any storefront experiment (e.g. sticky-mobile-atc).
 *
 * This has to happen storefront-side because Shopify's checkout runs
 * in a separate, sandboxed context that pixels can't reach into (no
 * shared cookies/localStorage with the storefront), so the only
 * reliable way to carry an identity across the cart -> checkout
 * boundary is a cart note attribute, which Shopify copies onto the
 * checkout object automatically.
 *
 * Runs globally (loaded from theme.liquid) so the attribute is set as
 * early as possible in a session, not just on product pages.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'gob_ph_distinct_id_synced';
  var POLL_INTERVAL_MS = 100;
  var MAX_ATTEMPTS = 40; // ~4s

  function syncDistinctId() {
    if (!window.posthog || typeof window.posthog.get_distinct_id !== 'function') return;

    var distinctId;
    try {
      distinctId = window.posthog.get_distinct_id();
    } catch (e) {
      return;
    }
    if (!distinctId) return;

    var alreadySynced = null;
    try {
      alreadySynced = window.sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {
      // sessionStorage unavailable (e.g. privacy mode) -- fall back to
      // syncing every page load rather than not syncing at all.
    }
    if (alreadySynced === distinctId) return;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { ph_distinct_id: distinctId } }),
    })
      .then(function (response) {
        if (!response.ok) return;
        try {
          window.sessionStorage.setItem(STORAGE_KEY, distinctId);
        } catch (e) {}
      })
      .catch(function () {
        // Network hiccup: leave alreadySynced unset so the next page
        // load in this session retries.
      });
  }

  var attempts = 0;
  var poll = setInterval(function () {
    attempts++;

    if (window.posthog && typeof window.posthog.get_distinct_id === 'function') {
      clearInterval(poll);
      syncDistinctId();
    } else if (attempts >= MAX_ATTEMPTS) {
      clearInterval(poll);
    }
  }, POLL_INTERVAL_MS);
})();
